import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router'
import firebase from 'firebase'
import db from './firebaseInit';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedRentalCalcId: '',
    user: null,
    error: null,
    loading: null,
    currentProperty: null
  },
  getters: {
    isAuthenticated(state) {
      return state.user !== null && state.user !== undefined;
    }
  },
  mutations: {
    setSelectedRentalCalc(state, payload){
      state.selectedRentalCalcId = payload;
    },
    setUserName(state, payload){
      state.userName = payload;
    },
    setUser(state, payload){
      state.user = payload;
    },
    setError(state, payload){
      state.error = payload;
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setCurrentProperty (state, payload) {
      state.currentProperty = payload;
    }
  },
  actions: {
    userSignUp({commit}, payload) {
      commit('setLoading', true);
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(firebaseUser => {
          commit('setUser', {email: firebaseUser.user.email, firstName: payload.firstName, lastName: payload.lastName});
          commit('setLoading', false);
          db.collection("users").add({
            firstName: payload.firstName,
            lastName: payload.lastName,
            userName: payload.email
          })
          .then(function(docRef) {
            console.log("New User Added with ID: ", docRef.id);
          })
          .catch(function(error) {
              console.error("Error adding New User: ", error);
          });
          router.push('/');
          })
        .catch(error => {
          commit('setError', error.message);
          commit('setLoading', false);
        })
    },
    userSignIn ({commit}, payload) {
      commit('setLoading', true)
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
      .then(firebaseUser => {
        commit('setLoading', false)
        commit('setError', null)
        var query = db.collection("users").where("userName", "==", firebaseUser.user.email);
        query.get().then(function(querySnapshot) {
          if (!querySnapshot.empty) {
            var queryDocSnapshot = querySnapshot.docs;
            if (queryDocSnapshot[0].exists){
              commit('setUser', queryDocSnapshot[0].data());
            }
            else {
              console.log("Cannot find user record for " + firebaseUser.user.email);
              throw "Cannot find user record for " + firebaseUser.user.email;
            }
            
          } else {  
            console.log("No such user! " + firebaseUser.user.email);
            throw "No such user! " + firebaseUser.user.email;
          }
          }).catch(function(error) {
              console.log("Error getting document:", error);
              throw "Error getting document:", error;
        });
        router.push('/')
      })
      .catch(error => {
        commit('setError', error.message)
        commit('setLoading', false)
        console.log("error: " + error.message);
      })
    },
    autoSignIn({commit}, payload) {
      commit('setUser', payload.email);
    },
    userSignOut({commit}) {
      firebase.auth().signOut();
      commit('setUser', null);
      router.push('/');
    }
  }
})
